import { render, staticRenderFns } from "./TopicReviewStatuses.vue?vue&type=template&id=bc0c70d8&scoped=true&"
import script from "./TopicReviewStatuses.vue?vue&type=script&lang=js&"
export * from "./TopicReviewStatuses.vue?vue&type=script&lang=js&"
import style0 from "./TopicReviewStatuses.vue?vue&type=style&index=0&id=bc0c70d8&lang=scss&scoped=true&"
import style1 from "./TopicReviewStatuses.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./TopicReviewStatuses.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0c70d8",
  null
  
)

export default component.exports